import React, { Component } from "react";
import {
  Jumbotron,
  Container,
  Row,
  Col,
  CardImg,
  Button
} from "reactstrap";
import { Link } from 'react-router-dom';

import "./style.css";
import { Helmet } from "react-helmet";

// checked

class StayRelevantPage extends Component {
  render() {
    return (
      <div className="overflow all-pages">
           <Helmet>
          <meta charSet="utf-8" />
          <title>Lighthouse</title>
          <link rel="canonical" href="http://atlighthouse.com" />

          <meta property="og:type" content="website" />
          <meta property="og:title" content="Lighthouse"></meta>
          <meta property="og:description" content="Be on a high-growth tech-career with project-based experiential learning, dedicated mentoring and career coaching."></meta>
          <meta property="og:url" content="https://atlighthouse.com"></meta>
          <meta name="twitter:card" content="summary_large_image"></meta>
          <meta name="twitter:site" content="@at_lighthouse"></meta>
          <meta name="twitter:title" content="Lighthouse"></meta>
          <meta name="twitter:description" content="Be on a high-growth tech-career with project-based experiential learning, dedicated mentoring and career coaching."></meta>
          <meta name="twitter:url" content="https://atlighthouse.com"></meta>
          <meta
            name="description"
            content="Be on a high-growth tech-career with project-based experiential learning, dedicated mentoring and career coaching."
          />
  
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1, shrink-to-fit=no"
          />
          <meta
            name="keywords"
            content="Coding Bootcamps, Technology Bootcamps, Tech bootcamps, Business and technology bootcamps, 
              Business bootcamps, Bootcamp, Programming, Become a Developer, Become a Software Developer, Learn Code,
              Get Hired for coding, Immersive program, Intensive program, Atlanta Coding bootcamps, Best coding bootcamps,Top coding bootcamps in Atlanta, Free coding bootcamp, Job guarantee bootcamp, Bootcamp with job guarantee,
              Steps to becoming a developer, Steps to becoming a web developer, Steps to becoming a software engineer, How to become a developer, How to become a programmer, How to become a web developer, How to become a full stack web developer, How to become a full stack developer, How to become a software developer, How to become a software engineer, How to become a data scientist, How to become a data analyst, How to become a digital marketer, How to become a UX designer, How to become an experience designer, How to become a UI designer, Coding bootcamp with job guarantee, Full time coding bootcamps, Part time coding bootcamps, Learn full stack web development, Learn web development, Learn software engineering, Learn data science, Learn data analytics, Learn digital marketing, Learn experience design, Learn ux design, Learn ui design, Full Stack Web Development Course, Full Stack Web Development Bootcamp, Full Stack Web Development Program, Full Stack Web Development Certificate, Atlanta Full Stack Development Course, Atlanta Full Stack Development Bootcamp, Atlanta Full Stack Development Program, Atlanta Full Stack Development Certificate, Data Science Course, Data Science Bootcamp, Data Science Program, Data Science Certificate, Atlanta Data Science Course, Atlanta Data Science Bootcamp, Atlanta Data Science Program, Atlanta Data Science Certificate, Software Engineering Course, Software Engineering Bootcamp, Software Engineering Program, Software Engineering Certificate, Atlanta Software Engineering Course, Atlanta Software Engineering Bootcamp, Atlanta Software Engineering Program, Atlanta Software Engineering Certificate, Digital Marketing Course, Digital Marketing Bootcamp, Digital Marketing Program, Digital Marketing Certificate, Atlanta Digital Marketing Course, Atlanta Digital Marketing Bootcamp, Atlanta Digital Marketing Program, Atlanta Digital Marketing Certificate, UX Course, UX Certificate, UX Bootcamp, UX Program, Atlanta UX Course, Atlanta UX Certificate, Atlanta UX Bootcamp, Atlanta UX Program, Competitive programming, How to get a job in programming, Bootcamps for college students, Coding bootcamps for college students, Best coding bootcamps in atlanta, Top rated coding bootcamps in atlanta, Top rated coding bootcamps, Best coding bootcamps, Rigorous coding bootcamps, Data Science bootcamps for college students, Best Data Science bootcamps in atlanta, Top rated Data Science bootcamps in atlanta, Top rated Data Science bootcamps, Best Data Science bootcamps, Can you get a job out of a coding bootcamp?, Talent Marketplace, Technology skills, Technology career, Career in software engineering, Career in data science, Career in digital marketing, Career in ux design, Career, Learn, Programming, Coding, Machine learning courses, Web development courses"
          />
          <meta name="theme-color" content="#000000" />
        </Helmet>
        <Jumbotron className="srf-jumbo" fluid>
          <Container fluid className="srf-container h-100">
             <img className="srf-logo-2" src={require("../images/stay-relevant-logo.svg")} alt="srf-logo" />
           
          </Container>
        </Jumbotron>
        <section className="first-section">
          <Container className="pt-lg-0">
            <Row className="justify-content-center justify-content-lg-start">
              <Col  xs={{ size: 11 }}>

                <h1 className="pb-2 all-headers  mb-3 text-center text-lg-left">How Do We Help You Evolve Your Career?</h1>
              
                <hr className="heading-underline1 mb-5" style={{ marginLeft: '0%', marginRight: '92%' }} />
              </Col>
            </Row>


            <Row className="text-left justify-content-center pt-3">
              <Col xs={{ size: 11 }} lg={{ size: 6 }}>
                <h3 style={{ fontWeight: 'normal' }} className="text-left">Lighthouse focuses on evolving your career based on what skills the market needs. Our curriculum and expert instructors are guided by our three principles:</h3>
                <ul className="mt-4" style={{ listStyleType: 'square', color: '#FFBD00' }}>
                  <li><p>Stay Relevant, Forever</p></li>
                  <li><p>Marked to Market Skill Building</p></li>
                  <li><p>Industry Partnerships</p></li>
                </ul>
              </Col>
              <Col xs={{ size: 11 }} sm={{ size: 6 }}>
                <CardImg
                  className="images how-do-we-help-you-img"
                  top
                  width="100%"
                  src="img/srf-how-do-we-help-v2.png"
                  alt="Card image cap"
                />
              </Col>
            </Row>
          </Container>
        </section >

        <section className="differentiator">
          <Container>
            <Row>
              <Col sm={{ size: 10, offset: 1 }}>
                <Row>
                  <Col sm={{ size: 12 }}>
                    <h1 className="all-headers text-center mt-5 mb-3">Stay Relevant, Forever</h1>
                    <hr className="heading-underline mb-5" />
                  </Col>
                </Row>
                <Row className="mb-5">
                  <Col xs={{ size: 12 }} lg={{ size: 6 }} className='pb-5'>
                    <CardImg
                      className="srf-images"
                      top
                      width="100%"
                      src="img/srf-stay-relevant-forever-v2.png"
                      alt="Card image cap"
                    />
                  </Col>
                  <Col xs={{ size: 12 }} lg={{ size: 6 }}>
                    <h3 style={{ fontWeight: 'normal', textAlign:"left" }}>The first of its kind. Traditional education institutions are incentivized on enrollment but not on students getting a job. We focus on the lifetime job opportunity of a student, and work to help you augment the skills most demanded by employers. This can help companies keep their teams relevant and adaptable. Learn more about our Stay Relevant, Forever ™ approach by contacting us today.</h3>
                  </Col>
                </Row>
                <Row>
                  <Col sm={{ size: 12 }}>
                    <h1 className="all-headers text-center mt-5 mb-3">Marked To Market Skill Building</h1>
                    <hr className="heading-underline mb-5" />
                  </Col>
                </Row>
                <Row className="mb-5">
                  <Col xs={{ size: 12 }} lg={{ size: 6 }} className='pb-5'>
                    <CardImg
                      className="srf-images"
                      top
                      width="100%"
                      src="img/srf-market-skill-v2.png"
                      alt="Card image cap"
                    />
                  </Col>
                  <Col xs={{ size: 12 }} lg={{ size: 6 }}>
                    <h3 style={{ fontWeight: 'normal', textAlign:"left" }}>Having spent decades in the technology services industry and building digital businesses, we are aware of multiple skills every engineer and developer needs to have. From business domain understanding, design thinking, to engineering, scalability on cloud, and more, we created our curriculum to help companies build a talent pipeline they can count on.</h3>
                  </Col>
                </Row>
             
                <Row>
                  <Col sm={{ size: 12 }}>
                    <h1 className="all-headers text-center mt-5 mb-3">Preparing Talent For Top Companies</h1>
                    <hr className="heading-underline mb-5" />
                  </Col>
                </Row>
                <Row className="mb-5">
                  <Col xs={{ size: 12 }} lg={{ size: 6 }} className='pb-5'>
                    <CardImg
                      className="srf-images"
                      top
                      width="100%"
                      src="img/srf-industry-partnerships-v2.png"
                      alt="Card image cap"
                    />
                  </Col>

                  <Col xs={{ size: 12 }} lg={{ size: 6 }}>
                    <h3 style={{ fontWeight: 'normal', textAlign:"left" }}>Partnerships with tech companies is essential to stay aligned with the latest development and also to be able to leverage resources. Partnerships with the likes of Blackrock and other top companies define what it takes to delight a customer with great product and experience. This helps us to never lose the fundamental aspect that technology exists to serve humans as customers.</h3>
                  </Col>
                </Row>
                <Row className="mb-5">
                  <Col>
                    <CardImg
                      className="d-none d-md-block "
                      top
                      width="100%"
                      src="img/industry-partners-v2.png"
                      alt="Card image cap"
                    />
                    <CardImg
                      className="d-block d-md-none"
                      top
                      width="100%"
                      src="img/m-industry-partners-v2.png"
                      alt="Card image cap"
                    />

                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
          <div className="are-you-ready-to-srf mt-5">
            <Container>
              <Row className="text-left">
                <Col sm={{ size: 6, offset: 1 }}>
                  <h1 className="all-headers mt-5 mb-3">Are You Ready To Stay Relevant, Forever?</h1>
                  <h3 style={{ fontWeight: 'normal' }} className="mt-5 mb-4">Our team is ready to help you Stay Relevant, Forever! Begin the next steps of your career path by choosing any course from our course catalogue. </h3>
                  <Link to='/browse'>
                    <Button className="courses-button">
                      View Our Courses
                    </Button>
                  </Link>
                </Col>
              </Row>
            </Container>
          </div>
        </section>
      </div >
    );
  }
}

export default StayRelevantPage;
